/*
  Input Text
*/

import React from "react";

// Antd
import { Input, Form } from "antd";

// Localization
import LOCALIZATION from "../../../../services/LocalizationService";

import {
  OPTIONAL_TEXT_SPACE_PATTERN,
  SPACE_VALIDATIOR,
} from "../../../../constants/Patterns";

// Style
import "./style.scss";

function Text({
  name,
  label,
  placeholder,
  readOnly,
  defaultValue,
  value,
  onChange,
  disabled,
  required,
  onBlur,
  validator,
  validateTrigger,
  maxLength,
  notwrapInForm,
  addonBefore,
  type,
  onPressEnter,
  style,
  /** Extra rules from parent (e.g. PERSONNEL_FORM_RULES). Merged after base rules. */
  rules: propRules,
}) {
  const isRequired = required === true;

  // Rules: optional fields must not fail SPACE_VALIDATIOR on empty string (old pattern required \S+).
  let rules = [
    ...(isRequired
      ? [{ required: true, message: LOCALIZATION.REQUIRED }]
      : []),
    {
      pattern: isRequired ? SPACE_VALIDATIOR : OPTIONAL_TEXT_SPACE_PATTERN,
      message: LOCALIZATION.SPACE_VALIDATION,
    },
  ];

  if (propRules && Array.isArray(propRules) && propRules.length > 0) {
    rules = rules.concat(propRules);
  }

  if (validator) {
    rules.push(validator);
  }

  // Input Text
  const InputText = (
    <Input
      placeholder={placeholder || label}
      onChange={onChange || null}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onPressEnter={onPressEnter}
      onBlur={onBlur}
      maxLength={maxLength || 100}
      readOnly={readOnly}
      addonBefore={addonBefore}
      type={type}
      style={style}
    />
  );

  return !!notwrapInForm ? (
    <>{InputText}</>
  ) : (
    <Form.Item
      name={name}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
    >
      {InputText}
    </Form.Item>
  );
}

export default Text;
